const algoliaSearchHandler = (() => {
	let queries = [];
	let timer = null;
	const requestMap = new Map();
	let cachedClientApi = null;

	function resolveClientApi() {
		if (cachedClientApi) {
			return cachedClientApi;
		}

		if (typeof window.createAlgoliaLiteClient !== "function") {
			console.error("Algolia client helper is unavailable.");
			return null;
		}

		const searchClient = window.createAlgoliaLiteClient(
			globalConfig.algoliaAppId,
			globalConfig.algoliaSearchApiKey,
		);

		if (!searchClient) {
			return null;
		}

		const runQueries =
			typeof searchClient.multipleQueries === "function"
				? searchClient.multipleQueries.bind(searchClient)
				: typeof searchClient.search === "function"
					? searchClient.search.bind(searchClient)
					: null;

		if (!runQueries) {
			console.error("Algolia search client is missing a query method.");
			return null;
		}

		cachedClientApi = { searchClient, runQueries };
		return cachedClientApi;
	}

	return {
		search(query) {
			return new Promise((resolve, reject) => {
				if (isBot()) {
					console.log("Bot detected, skipping Algolia search.");
					return resolve([]);
				}

				const clientApi = resolveClientApi();
				if (!clientApi) {
					return resolve([]);
				}

				const { runQueries } = clientApi;
				const requestKey = `${query.indexName}:${requestMap.size}`;
				if (!requestMap.has(requestKey)) {
					requestMap.set(requestKey, []);
				}
				requestMap.get(requestKey).push(resolve);

				queries.push(query);
				if (timer) {
					clearTimeout(timer);
				}

				timer = setTimeout(() => {
					if (queries.length === 0) return;

					runQueries(queries)
						.then((response) => {
							response.results.forEach((result, i) => {
								const key = `${result.index}:${i}`;

								if (requestMap.has(key)) {
									requestMap.get(key).forEach((resolveFn) => resolveFn(result));
									requestMap.delete(key);
								}
							});
						})
						.catch((error) => {
							reject(error);
						})
						.finally(() => {
							queries = [];
							timer = null;
						});
				}, 200);
			});
		},
	};
})();
